import { BorderedBox } from "../components";
import { Row, Col, TabPane } from "reactstrap";
import {
	imageModalReducerActions,
	useImageModalContext,
} from "contexts/imageModal";
import { useReducer, useRef } from "react";
import { useFieldArray } from "react-hook-form";
import { ProtectedImg, ImageModal, CustomAlert } from "components";
import {
	confirmationModalReducer,
	confirmationModalReducerActions,
	confirmationModalInitialState,
} from "./reducers";
import { FiPlus, FiX } from "react-icons/fi";
import { ImageUploadv2 } from "components/CustomUpload/ImageUploadv2";
import { imageTypes } from "../constants";

export const InClassPhotos = ({
	studentRecord: { lessonFiles, studentReportApproved },
	canEdit = false,
	control,
	editable,
}) => {
	const fileInputRef = useRef(null);
	const {
		fields: inClassPhotos,
		remove,
		append,
	} = useFieldArray({
		control,
		name: "inClassPhotos",
	});

	const { dispatch: imageModalDispatch } = useImageModalContext();

	const [confirmationModalProps, confirmationModalDispatch] = useReducer(
		confirmationModalReducer,
		confirmationModalInitialState
	);

	const triggerConfirmationModal = (index) => () => {
		confirmationModalDispatch({
			type: confirmationModalReducerActions.OPEN,
			payload: index,
		});
	};

	const closeConfirmationModal = () =>
		confirmationModalDispatch({
			type: confirmationModalReducerActions.CLOSE,
		});

	const submitConfirmationModal = (index) => () => {
		remove(index);
		confirmationModalDispatch({
			type: confirmationModalReducerActions.CLOSE,
		});
	};

	return (
		<TabPane tabId={3} key={3}>
			<Row>
				<CustomAlert
					show={confirmationModalProps.show}
					hideModal={closeConfirmationModal}
					title="Confirmation"
					description={
						<span className="text-warning">
							Delete In Class Photo?
						</span>
					}
					submitButtonText="Delete"
					submitModal={submitConfirmationModal(
						confirmationModalProps.indexToDelete
					)}
					fitToParent={true}
				/>
				<Col sm="12">
					<BorderedBox className="align-items-center">
						{inClassPhotos?.length ? (
							inClassPhotos?.map((lessonFile, index) => (
								<div
									className="col-6 col-sm-4 col-md-3 col-lg-2"
									key={lessonFile.id}
								>
									{(canEdit || editable) &&
										!studentReportApproved && (
											<FiX
												onClick={triggerConfirmationModal(
													index
												)}
												style={{ cursor: "pointer" }}
												className="text-danger"
											/>
										)}
									<ProtectedImg
										src={
											lessonFile.filepath ||
											lessonFile.data
										}
										className="img-fluid rounded"
										onClick={() =>
											imageModalDispatch({
												type: imageModalReducerActions.SHOW,
												payload: lessonFile.filepath,
											})
										}
									/>
								</div>
							))
						) : (
							<div className="ml-2 d-flex align-items-center">
								No in class photos
							</div>
						)}
						{(canEdit || editable) && !studentReportApproved && (
							<ImageUploadv2
								fileInputRef={fileInputRef}
								setValue={(_, imgURI) =>
									append({
										new: true,
										type: imageTypes.IN_CLASS_IMAGES,
										data: imgURI,
									})
								}
								labelText="Click to upload"
								disableImgGallery={true}
								marginClass="m-3"
							/>
						)}
					</BorderedBox>
				</Col>
			</Row>
		</TabPane>
	);
};
